'use client';

import { BrowserPersistence } from '@/util';

import { useUserContext } from '@/context/user';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

const NavigationAvatar = () => {
  const [{ isSignedIn }] = useUserContext();

  return (
    <Link
      href={isSignedIn ? '/my-account' : '/sign-in'}
      className={clsx(
        'flex h-[63px] flex-none items-center gap-x-[7px] pl-[15px]',
        'border-y-1 border-solid border-E7DED5',
      )}
      onClick={() => {
        if (!isSignedIn) {
          const storage = new BrowserPersistence();

          storage.setItem('redirect', globalThis.location.pathname + globalThis.location.search);
        }
      }}
    >
      {isSignedIn ? (
        <Image
          src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/home/avatar.png`}
          width={90}
          height={90}
          alt='avatar'
          className='h-auto w-12'
        />
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          fill='none'
          viewBox='0 0 24 25'
        >
          <path
            fill='#80583F'
            d='M15.111 14.188c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 0 0-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.68 11.68 0 0 0-7.97 9.08c-.07.41.2.81.61.88s.81-.2.88-.61a10.2 10.2 0 0 1 9.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09m-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63'
          />
          <path
            fill='#000'
            fillOpacity='0.2'
            d='M15.111 14.188c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 0 0-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.68 11.68 0 0 0-7.97 9.08c-.07.41.2.81.61.88s.81-.2.88-.61a10.2 10.2 0 0 1 9.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09m-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63'
          />
        </svg>
      )}
      <span>{isSignedIn ? 'My Account' : 'Sign Up'}</span>
    </Link>
  );
};

export default NavigationAvatar;
